import {Icon, PriorityIcon} from '@priority-software/priority-style-react';
import React, {MouseEvent} from 'react';
import cx from 'classnames';
import style from '../styles/formInputButton.module.scss';

type Props = {
    icon: PriorityIcon;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    isPrimary?: boolean;
    componentClasses?: string;
};

export const FormInputButton = ({icon, onClick, isPrimary, componentClasses}: Props) => {
    return (
        <div className={cx(style.button, {[style.primary]: isPrimary}, componentClasses)}>
            <Icon
                skin="standart"
                icon={icon}
                hoverable
                onClick={onClick}
                componentClasses={style.icon}
            />
        </div>
    );
};
